export const printHtml = (html) => {

	const closePrint = (oHideFrame) => {
		document.body.removeChild(oHideFrame);
	}
	const setPrint = (oHideFrame) => {
		oHideFrame.contentWindow.__container__ = this;
		oHideFrame.contentWindow.onbeforeunload = () => closePrint(oHideFrame);
		oHideFrame.contentWindow.onafterprint = () => closePrint(oHideFrame);
		oHideFrame.contentWindow.focus(); // Required for IE
		oHideFrame.contentWindow.print();
	}
	const printPage = () => {
		var oHideFrame = document.createElement("iframe");
		oHideFrame.onload = ()=>setPrint(oHideFrame);
		oHideFrame.style.position = "fixed";
		oHideFrame.style.right = "0";
		oHideFrame.style.bottom = "0";
		oHideFrame.style.width = "0";
		oHideFrame.style.height = "0";
		oHideFrame.style.border = "0";
		oHideFrame.srcdoc = html;
		document.body.appendChild(oHideFrame);
	}
	return printPage();
}

export const tempInvoice = `<html>
<head>
    <style>
        table tr td, table tr th {
            padding: 4px;
        }
    </style>
</head>
<body class="ck-content" style="font-family: Arial, Helvetica, sans-serif;">
	<div id="body">
        <div>
            <h2>TAX INVOICE</h2>
        </div>
        <div style="display: flex;width: 100%;">
            <div style="width: 50%;">
                <p style="font-weight: bold;">FROM</p>
                <p>Plasma Telecom South Africa (Pty) Ltd</p>
                <p>Wrigley Field Building, The Campus</p>
                <p>57 Sloane Street</p>
                <p>Bryanston</p>
                <p>2057</p>
            </div>
            <div style="width: 50%;">
                <img src="https://i.ibb.co/PCxDFgc/logo.jpg" alt="Logo" style="height: 100%; width: auto;">
            </div>
        </div>
        <div style="display: flex;width: 100%;">
            <div style="width: 60%;">
                <p style="font-weight: bold;">TO</p>
                <p>#CONTACT_NAME</p>
                <p>#CONTACT_PHONE</p>
                <p>#BILLING_ADDRESS</p>
            </div>
            <div style="width: 40%;">
                <p style="font-weight: bold;text-transform: uppercase;">Customer Service</p>
                <p>Email: help@fly.cool</p>
                <p>Whatsapp us on: 0110655314</p>
                <p>www.fly.cool</p></div>
            </div>
        </div>
        <div>
            <table style="width: 100%;">
                <tbody>
                    <tr>
                        <td><p>Invoice number: <span style="font-weight: bold;">#INVOICE_NUMBER</span></p></td>
                        <td style="text-align: center;"><p>Invoice date: <span style="font-weight: bold;">#INVOICE_DATE</span></p></td>
                        <td style="text-align: right;"><p>Invoice due date: <span style="font-weight: bold;">#INVOICE_DUE_DATE</span></p></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div>
            <table style="width: 100%;border-collapse: collapse">
                <thead>
                    <tr>
                        <th style="border: 1px solid #cccccc;text-align: center;">Product</th>
                        <th style="border: 1px solid #cccccc;text-align: center;">Description</th>
                        <th style="border: 1px solid #cccccc;text-align: center;">Quantity</th>
                        <th style="border: 1px solid #cccccc;text-align: center;">Unit Price</th>
                        <th style="border: 1px solid #cccccc;text-align: center;">Discount</th>
                        <th style="border: 1px solid #cccccc;text-align: center;">Sub Total</th>
                    </tr>
                </thead>
                <tbody>
                    #ITEM_INFO
                </tbody>
                <tfoot>
                    <tr>
                        <td style="text-align: right;" colspan="5"><span style="font-weight: bold;">Total Net Amount</span></td>
                        <td style="text-align: center;"><span>#TOTAL_NET_AMOUNT</span></td>
                    </tr>
                    <tr>
                        <td style="text-align: right;" colspan="5"><span style="font-weight: bold;">Total Discount Amount</span></td>
                        <td style="text-align: center;"><span>#TOTAL_DISCOUNT_AMOUNT</span></td>
                    </tr>
                    <tr>
                        <td style="text-align: right;" colspan="5"><span style="font-weight: bold;">Total Tax Amount</span></td>
                        <td style="text-align: center;"><span>#TOTAL_TAX_AMOUNT</span></td>
                    </tr>
                    <tr>
                        <td style="text-align: right;" colspan="5"><span style="font-weight: bold;">Total Amount</span></td>
                        <td style="text-align: center;"><span>#TOTAL_AMOUNT</span></td>
                    </tr>
                    <tr>
                        <td style="text-align: right;" colspan="5"><span style="font-weight: bold;">Overdue Amount</span></td>
                        <td style="text-align: center;"><span>#OVERDUE_AMOUNT</span></td>
                    </tr>
                </tfoot>
            </table>
        </div>
        <div style="position: fixed; bottom: 10px;">
            <p style="font-weight: bold;font-size: 12px;">Plasma Telecom South Africa (Pty) Ltd</p>
            <p style="font-size: 12px;">Wrigley Field Building, The Campus , 57 Sloane Street, Bryanston, 2057</p>
        </div>
    </div>
</body>

</html>`;

export const tempItemInvoice = `<tr>
<td style="text-align: center;border: 1px solid #cccccc;">#PRODUCT_NAME</td>
<td style="text-align: center;width: 15%;border: 1px solid #cccccc;">
	<span>#DESCRIPTION</span>
</td>
<td style="text-align: center;border: 1px solid #cccccc;">#QUANTITY</td>
<td style="text-align: center;border: 1px solid #cccccc;">#PRICE</td>
<td style="text-align: center;border: 1px solid #cccccc;">#DISCOUNT</td>
<td style="text-align: center;border: 1px solid #cccccc;">#SUB_TOTAL</td>
</tr>`
//<td style="text-align: center;border: 1px solid #cccccc;">#ORDER_NUMBER</td>